import React, {useState, useEffect} from "react";
import Text from "connectui/component/display/Text";
import Divider from "connectui/component/display/Divider";
import Switch from "connectui/component/input/Switch";
import FlexContainer from "connectui/component/layout/FlexContainer";
import Container from "connectui/component/layout/Container";
import {useDispatch, useSelector} from "react-redux";
import {updateAutoresponderService} from "redux/actions/servicesActions";

export default function AIAutopilot() {
  const userProfile = useSelector((state) => state.defaultReducer.user_profile);
  const autoresponderEnabled =
    userProfile?.connected_services?.includes("autoresponder");
  const [autopilotOn, setAutopilotOn] = useState(autoresponderEnabled);
  useEffect(() => {
    setAutopilotOn(autoresponderEnabled);
  }, [autoresponderEnabled]);
  const dispatch = useDispatch();

  const handleToggle = () => {
    const currValue = autopilotOn;
    setAutopilotOn(!currValue);
    dispatch(
      updateAutoresponderService({
        enable: !currValue,
        onError: () => setAutopilotOn((prev) => currValue),
      }),
    );
  };

  // Styles similar to BaseMessagingSettingsPanel
  const baseContainerSx = {
    backgroundColor: "#fff",
    width: "100%",
    height: "100%",
    overflowY: "auto",
  };
  const contentContainerSx = {
    width: "100%",
    height: "100%",
    padding: "0 40px",
    display: "flex",
    flexDirection: "column",
  };
  const componentContainerSx = {
    marginTop: 48,
  };

  return (
    <Container sx={baseContainerSx}>
      <FlexContainer sx={contentContainerSx} flexDirection="column">
        <Container sx={componentContainerSx}>
          <Text variant="textXL" weight="bold" sx={{marginBottom: 8}}>
            AI Autopilot
          </Text>
          <Text
            variant="textMD"
            color="textSecondary"
            sx={{marginBottom: 32, marginTop: 8}}
          >
            Let Enso AI handle guest questions for you.
          </Text>
          <FlexContainer
            alignItems="center"
            sx={{marginBottom: 24, marginTop: 24}}
          >
            <Container sx={{flexGrow: 1}}>
              <Text
                variant="textMD"
                weight="medium"
                as="div"
                sx={{marginBottom: 4}}
              >
                Autopilot
              </Text>
              <Text variant="textSM" color="textSecondary">
                Turn the AI Autopilot on or off. When enabled, Enso AI can start
                replying to guests based on your preferences.
              </Text>
            </Container>
            <Switch
              isChecked={autopilotOn}
              onChange={() => handleToggle()}
              key={autopilotOn ? "on" : "off"}
            />
            <Text
              variant="textMD"
              weight="bold"
              color="textSecondary"
              sx={{marginLeft: 12}}
            >
              {autopilotOn ? "ON" : "OFF"}
            </Text>
          </FlexContainer>
          <Divider />
        </Container>
      </FlexContainer>
    </Container>
  );
}
